export default "__VITE_ASSET__3d4b66f9__"